export default "__VITE_ASSET__CeLNig8i__"